//-- Copyright (c) 2021 TMT Insights Group, LLC
import PolarisIcon from '@/components/_common/PolarisIcon';
import { useAppDispatch } from '@/redux/hooks';
import { getData } from '@/redux/slices/dataTableSlice';
import { IconButton, Tooltip } from '@mui/material';

interface RefreshTableProps {
  onRefresh?: () => void;
}

const RefreshTable = ({ onRefresh }: RefreshTableProps) => {
  const dispatch = useAppDispatch();

  const handleRefresh = () => {
    dispatch(getData());

    if (onRefresh) {
      onRefresh();
    }
  };

  return (
    <Tooltip title="Refresh Content">
      <IconButton data-testid="refresh-content" onClick={handleRefresh} size="small">
        <PolarisIcon icon="refresh" height={20} />
      </IconButton>
    </Tooltip>
  );
};

export default RefreshTable;
